// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__D8IyR","fullScreen":"layout_fullScreen__q0b_D","unmounted":"layout_unmounted__2mQtq","mounted":"layout_mounted__LFqug"};